import { defineComponent as r, computed as o, openBlock as a, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as _ } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "db7f861a-12a0-4237-9698-a15b9fbaa88c" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#db7f861a-12a0-4237-9698-a15b9fbaa88c)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v167H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M0 345h512v167H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "m153 194.8 13.8 42.5h44.7l-36.2 26.3 13.8 42.5-36.1-26.3-36.2 26.3 13.8-42.5-36.2-26.3h44.7zm206 0 13.9 42.5h44.7l-36.2 26.3 13.8 42.5-36.2-26.3-36.1 26.3 13.8-42.5-36.2-26.3h44.7z"
}, null, -1), w = { fill: "none" }, y = ["r"], B = /* @__PURE__ */ r({
  __name: "sy",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (z, b) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (a(), i("title", p, d(t.flagName), 1)) : h("", !0),
        k,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=sy-a4ba77c8.js.map
